(function ($) {
  Drupal.behaviors.offersHero = {
    attach: function (context) {
      var $detailsLink = $('.offers-hero__link', context);
      var $description = $('.offers-hero__description', context);
      var $dropdown = $('.offers-hero__dropdown', context);
      var $content = $('.offers-hero__dropdown-content > div', $dropdown);
      var currentBreakpoint = Unison.fetch.now().name;

      if (currentBreakpoint == 'small') {
        $description.after($dropdown);
      }
      $detailsLink.click(function (event) {
        event.preventDefault();
        $dropdown.toggle();
        $content.matchHeight();
      });
    }
  };
})(jQuery);
